<template id="map-template">
  <div class="homeview-device-data">
    <div class="header">
      <span class="header-title">设备</span>
      <div class="arrow-pic"></div>
      <!-- <div class="icon-spread"></div> -->
    </div>
    <div class="table-chart">
      <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
        <el-table-column prop="Name" label="名称"></el-table-column>
        <el-table-column prop="TotolCount" label="总数"></el-table-column>
        <el-table-column prop="ExceptionCount" label="故障">
           <template slot-scope="scope">
            <span v-if="scope.row.ExceptionCount > 0" style="color:red;">{{scope.row.ExceptionCount}}</span>
            <span v-else>{{scope.row.ExceptionCount}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import ZJApp from '../../../../../app';

export default {
  name: "HomeViewDeviceList",
  componentName: "HomeViewDeviceList",
  components: {},
  props: {},
  data() {
    return {
      tableData: []
    };
  },
  created() {},
  mounted: function () {
    this.search();
  },
  methods: {
    search(){
      ZJApp.ZJUtils.waitAll([
       //() => this.searchLed(),
       () => this.searchMonitor(),
       () => this.searchSos(),
       () => this.GetWifiList(),
       () => this.GetBroadCastList(),
       () => this.searchGate(),
       //()=>this.searchStreetLamp(),
       //() => this.searchSprinklingIrrigation(),
       //()=>this.searchComputerRoom(),
       //()=>this.searchFireMonitoring(),
      ]).then((r) => {
        this.tableData = r;
      },(e) =>{ console.log(e);});
    },
    searchLed() {
      let searchInfo = {
        Ledtype:  -1 ,
        PageSize: 1000,
        PageIndex: 0,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      return new Promise(function (resolve, reject) {
        new MyApis.LedApi().GetItemPagingList(searchInfo)
        .then(r=>{
            r = r.data.Data;
            //let list  = r.PageContents;
            let exceptionCount = 0;
            let data = {
              Name:"LED",
              TotolCount:r.BaseSearch.TotalCount,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });
    },
    searchMonitor() {
      let searchInfo = {
        "EquipmentType": "Monitor",
        "DeviceType":"SubSystem.Monitor.EquipmentType.Monitor",
        "PageSize": 1000,
        "PageIndex": 1,
        "TotalCount": 0,
        "StartNumber": 0,
        "EndNumber": 0
      };
      return new Promise(function (resolve, reject) {
        new MyApis.BaseDataApi().GetEquipmentPagingList(searchInfo)
        .then(r=>{
            r = r.data.Data;
            let list  = r.PageContents;
            let exceptionCount = list.filter(function(item){return !item.IsOnline;}).length;
            let data = {
              Name:"监控设备",
              TotolCount:r.BaseSearch.TotalCount,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });
    },
    //sos
    searchSos() {
      let searchInfo = {
        "EquipmentType": "Monitor",
        "DeviceType":"SubSystem.Monitor.EquipmentType.Sos",
        "PageSize": 1000,
        "PageIndex": 1,
        "TotalCount": 0,
        "StartNumber": 0,
        "EndNumber": 0
      };
      return new Promise(function (resolve, reject) {
        new MyApis.BaseDataApi().GetEquipmentPagingList(searchInfo)
        .then(r=>{
            r = r.data.Data;
            let list  = r.PageContents;
            let exceptionCount = list.filter(function(item){return !item.IsOnline;}).length;
            let data = {
              Name:"SOS设备",
              TotolCount:r.BaseSearch.TotalCount,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });
    },
    //路灯
    searchStreetLamp() {
      let searchInfo = {
        "EquipmentType": "MapPOI",
        "DeviceType":"SubSystem.Map.POIType.StreetLamp",
        "PageSize": 1000,
        "PageIndex": 1,
        "TotalCount": 0,
        "StartNumber": 0,
        "EndNumber": 0
      };
      return new Promise(function (resolve, reject) {
        new MyApis.BaseDataApi().GetEquipmentPagingList(searchInfo)
        .then(r=>{
            r = r.data.Data;
            let list  = r.PageContents;
            let exceptionCount = list.filter(function(item){return !item.IsOnline;}).length;
            let data = {
              Name:"路灯",
              TotolCount:r.BaseSearch.TotalCount,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });
    },
    //喷灌
    searchSprinklingIrrigation() {
      let searchInfo = {
        "EquipmentType": "MapPOI",
        "DeviceType":"SubSystem.Map.POIType.SprinklingIrrigation",
        "PageSize": 1000,
        "PageIndex": 1,
        "TotalCount": 0,
        "StartNumber": 0,
        "EndNumber": 0
      };
      return new Promise(function (resolve, reject) {
        new MyApis.BaseDataApi().GetEquipmentPagingList(searchInfo)
        .then(r=>{
            r = r.data.Data;
            let list  = r.PageContents;
            let exceptionCount = list.filter(function(item){return !item.IsOnline;}).length;
            let data = {
              Name:"喷灌",
              TotolCount:r.BaseSearch.TotalCount,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });
    },
    //机房
    searchComputerRoom() {
      let searchInfo = {
        "EquipmentType": "MapPOI",
        "DeviceType":"SubSystem.Map.POIType.ComputerRoom",
        "PageSize": 1000,
        "PageIndex": 1,
        "TotalCount": 0,
        "StartNumber": 0,
        "EndNumber": 0
      };
      return new Promise(function (resolve, reject) {
        new MyApis.BaseDataApi().GetEquipmentPagingList(searchInfo)
        .then(r=>{
            r = r.data.Data;
            let list  = r.PageContents;
            let exceptionCount = list.filter(function(item){return !item.IsOnline;}).length;
            let data = {
              Name:"机房",
              TotolCount:r.BaseSearch.TotalCount,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });
    },
    //火情监测
    searchFireMonitoring() {
      let searchInfo = {
        "EquipmentType": "MapPOI",
        "DeviceType":"SubSystem.Map.POIType.FireMonitoring",
        "PageSize": 1000,
        "PageIndex": 1,
        "TotalCount": 0,
        "StartNumber": 0,
        "EndNumber": 0
      };
      return new Promise(function (resolve, reject) {
        new MyApis.BaseDataApi().GetEquipmentPagingList(searchInfo)
        .then(r=>{
            r = r.data.Data;
            let list  = r.PageContents;
            let exceptionCount = list.filter(function(item){return !item.IsOnline;}).length;
            let data = {
              Name:"火情监测",
              TotolCount:r.BaseSearch.TotalCount,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });
    },
    searchGate() {
      let searchInfo = {
        "DeviceType": "Gate",
        "PageSize": 1000,
        "PageIndex": 1,
        "TotalCount": 0,
        "StartNumber": 0,
        "EndNumber": 0
      };
    
      return new Promise(function (resolve, reject) {
        new MyApis.BaseDataApi().GetEquipmentPagingList(searchInfo)
        .then(r=>{
            r = r.data.Data;
            let list  = r.PageContents;
            let exceptionCount = list.filter(function(item){return !item.IsOnline;}).length;
            let data = {
              Name:"闸机",
              TotolCount:r.BaseSearch.TotalCount,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });
    },
    GetWifiList()
    {
      let searchInfo = {
        "Status":-1,
        "PageSize": 1000,
        "PageIndex": 1,
        "TotalCount": 0,
        "StartNumber": 0,
        "EndNumber": 0
      };
    
    
      return new Promise(function (resolve, reject) {
        new MyApis.TranResourcesApi().GetDeviceListPaging(searchInfo)
        .then(r=>{
            r = r.data.Data;
            let list  = r.PageContents;
            let exceptionCount = list.filter(function(item){return item.Status==0;}).length;
            let data = {
              Name:"无线热点",
              TotolCount:list.length,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });

    },
    GetBroadCastList()
    {
      let searchInfo = {
        "DeviceName": null,
        "RegionId": null,
        "EquipmentType": "Broadcast",
        "PageSize": 1000,
        "PageIndex": 1,
        "TotalCount": 0,
        "StartNumber":0,
        "EndNumber":0
      };
    
      return new Promise(function (resolve, reject) {
        new MyApis.BaseDataApi().GetEquipmentPagingList(searchInfo)
        .then(r=>{
            r = r.data.Data;
            let list  = r.PageContents;
            let exceptionCount = list.filter(function(item){return !item.IsOnline;}).length;
            let data = {
              Name:"广播",
              TotolCount:r.BaseSearch.TotalCount,
              ExceptionCount :exceptionCount || 0
            };   
            resolve(data);
        },
        e=>reject(e));
      });
    }
  },
  beforeDestroy() {},
  destroyed() {}
};
</script>